module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue_m.68c7dd2105be2bbe18aba8e7446a30c0.png";